<div class="radio-buttons-container">
  @for (item of items; track item) {
    <label [class.disabled]="disabled">
      <input type="radio"
        name="{{name}}"
        [disabled]="disabled"
        [value]="item.value"
        [checked]="item.isSelected"
        (click)="onSelect(item)"><span>{{item.display}}</span>
      </label>
    }
  </div>